/* AFORDA collection breadcrumb: reliably visible after leaving collection header. */
(() => {
  if (window.__afordaModelBreadcrumbV2) return;
  window.__afordaModelBreadcrumbV2 = true;

  function init() {
    const hero = document.querySelector('.aforda-adidas-collection-hero');
    const original = hero?.querySelector('.aforda-collection-breadcrumb');
    if (!hero || !original) return;

    document.querySelectorAll('.aforda-model-sticky-crumb').forEach((node) => node.remove());

    const bar = document.createElement('div');
    bar.className = 'aforda-model-sticky-crumb';
    bar.setAttribute('role', 'navigation');
    bar.setAttribute('aria-label', 'Adidas model breadcrumb');
    const crumb = original.cloneNode(true);
    crumb.removeAttribute('aria-label');
    bar.appendChild(crumb);
    document.body.appendChild(bar);

    let queued = false;
    const update = () => {
      queued = false;
      const heroBounds = hero.getBoundingClientRect();
      const stickyHeader = document.querySelector('sticky-header');
      let offset = 0;
      if (stickyHeader) {
        const rect = stickyHeader.getBoundingClientRect();
        // Header is only counted when it is actually occupying the top of the screen.
        if (rect.top <= 1 && rect.bottom > 0) offset = rect.bottom;
      }
      bar.style.top = Math.max(0, Math.round(offset)) + 'px';
      const visible = heroBounds.bottom <= Math.max(0, offset) + 2;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }
})();